import { useState, type ReactNode } from 'react'

import { Button } from '@/src/elements/button/default'
import { Textarea } from '@/src/elements/input/Textarea'
import { Message } from '@/src/elements/message'
import { Typography } from '@/src/elements/text/Typography'
import { useReportAbuseMutation, type TUseReportAbuseProps } from '@/src/features/abuse/services/useReportAbuseMutation'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

export type TReportAbuseFormProps = {
  onEnd: VoidFunction
} & TUseReportAbuseProps

export const ReportAbuseForm = ({ onEnd, ...props }: TReportAbuseFormProps): ReactNode => {
  const [reason, setReason] = useState('')
  const { t } = useTranslate()

  const reportAbuse = useReportAbuseMutation(props)

  const handleSend = () => {
    if (reason) reportAbuse.mutate({ reason })
  }

  if (reportAbuse.isSuccess) {
    return (
      <>
        <Message colors="success" iconName={ICON.CHECK_CIRCLE_BROKEN}>
          {t('app.report-issue.thank-you')}
        </Message>
        <Button colors="primary" variant="solid" onPress={onEnd} className="self-end">
          {t('word.continue')}
        </Button>
      </>
    )
  }

  return (
    <>
      <Typography colors="default">{t('app.report-abuse.reason')}</Typography>
      <Textarea
        inBottomSheet
        classNames={{ input: 'min-h-[150px]' }}
        value={reason}
        onChangeText={setReason}
        placeholder={t('app.report-abuse.placeholder')}
      />
      <Button
        colors="primary"
        variant="solid"
        isLoading={reportAbuse.isPending}
        isDisabled={!reason}
        onPress={handleSend}
        className="self-end"
      >
        {t('app.report-abuse.send')}
      </Button>
    </>
  )
}
